import React from 'react';
import useTreatments from '../../store/treatments/treatmentsContext';
import Modal from '../../components/Modals/Modal';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import FileInput from '../../components/Inputs/FileInput';
import classNames from '../../utils/classNames';
import { Switch } from '@headlessui/react';
import { useMemo } from 'react';

function AddTreatmentModal({
  showAddTreatmentDocument,
  setShowAddTreatmentDocument,
  treatmentId,
  user
}) {

  const {
    uploadTreatmentDocument,
  } = useTreatments();

  const isPatient = useMemo(() => {
    let _isPatient = false;
    if (user.user_type === 'patient') _isPatient = true;

    return _isPatient
  }, [user])

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  const [file, setFile] = React.useState(null)
  const [patientViewable, setPatientViewable] = React.useState(false);
  
  const handleFileUpload = (e) => { 
    setFormError({
      field: '',
      msg: ''
    })
    setFile(e.target.files[0]);
  } 

  const handleCancelAddTreatmentDocument = () => {
    setFile(null);
    setShowAddTreatmentDocument(false);
    setFormError({
      field: '',
      msg: ''
    });
  }

  const uploadFile = () => {
    if (file) {
      uploadTreatmentDocument(treatmentId, file, (isPatient ? true : patientViewable));
      setShowAddTreatmentDocument(false);
      return;
    }
    setFormError({
      field: 'file',
      msg: 'Please include a file to upload'
    })
  }

  return (
    <Modal title={'Upload treatment document'} show={showAddTreatmentDocument} hide={handleCancelAddTreatmentDocument}>
      <div className='flex flex-col justify-between'>
        {!isPatient && 
          <div className='flex justify-between mt-8'>
            <label className="text-secondary">Patient viewable</label>
              <Switch
                checked={patientViewable}
                onChange={e => setPatientViewable(!patientViewable)}
                className={classNames(
                  patientViewable ? 'bg-primary' : 'bg-gray-200',
                  'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none'
                )}
              >
                <span className="sr-only">Use setting</span>
                <span
                  aria-hidden="true"
                  className={classNames(
                    patientViewable ? 'translate-x-5' : 'translate-x-0',
                    'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                  )}/>
              </Switch>
          </div>
        }
        <div className='flex flex-col items-center justify-around mt-16 mb-8'>
          {formError.field === 'file' &&
          <span className="text-red-400 text-sm">{formError.msg}</span>
          }
          <FileInput top handleFileUpload={handleFileUpload} buttonText='Select file'/>
        </div>
        <div className='grid grid-cols-2 gap-x-2'>
          <SecondaryButton onClick={handleCancelAddTreatmentDocument} text='Cancel'/>  
          <PrimaryButton onClick={uploadFile} text='Upload'/>
        </div>
      </div>
    </Modal>
  )
}

export default AddTreatmentModal
